export var EVENTS = {
	MODAL_CLOSE: 'MODAL_CLOSE',
	DATA_CHANGED: 'DATA_CHANGED'
}